import { FC } from "react";
import { CommonIconProps } from "../Icon/types";

const ReportCenter: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-report-center"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path d="M19.5 8.55566C19.4999 7.85284 19.0713 7.50009 18.7783 7.5H10.2227C9.92875 7.5 9.50014 7.85298 9.5 8.55566V19.4443C9.50014 20.147 9.92875 20.5 10.2227 20.5H18.7773C19.0714 20.5 19.4999 20.1468 19.5 19.4453V8.55566ZM16.8896 16.6104C17.1658 16.6104 17.3896 16.8342 17.3896 17.1104C17.3895 17.3863 17.1657 17.6104 16.8896 17.6104H12.2197C11.9438 17.6102 11.7199 17.3862 11.7197 17.1104C11.7197 16.8343 11.9437 16.6105 12.2197 16.6104H16.8896ZM16.8896 13.5C17.1658 13.5 17.3896 13.7239 17.3896 14C17.3896 14.2761 17.1658 14.5 16.8896 14.5H12.2197C11.9437 14.4999 11.7197 14.2761 11.7197 14C11.7197 13.7239 11.9437 13.5001 12.2197 13.5H16.8896ZM16.8896 10.3896C17.1657 10.3896 17.3895 10.6137 17.3896 10.8896C17.3896 11.1658 17.1658 11.3896 16.8896 11.3896H12.2197C11.9437 11.3895 11.7197 11.1657 11.7197 10.8896C11.7199 10.6138 11.9438 10.3898 12.2197 10.3896H16.8896ZM20.5 19.4453C20.4999 20.4615 19.8345 21.5 18.7773 21.5H10.2227C9.1653 21.5 8.50015 20.4613 8.5 19.4443V8.55566C8.50015 7.53868 9.1653 6.5 10.2227 6.5H17.5V5C17.5 4.17114 16.8289 3.5 16 3.5H5C4.17114 3.5 3.5 4.17114 3.5 5V10C3.5 10.8289 4.17114 11.5 5 11.5H7C7.27614 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.27614 12.5 7 12.5H5C3.61886 12.5 2.5 11.3811 2.5 10V5C2.5 3.61886 3.61886 2.5 5 2.5H16C17.3811 2.5 18.5 3.61886 18.5 5V6.5H18.7783C19.835 6.50007 20.4999 7.53894 20.5 8.55566V19.4453Z" />
    </svg>
  );
};

export default ReportCenter;
